<script setup lang="ts">
import { ref } from 'vue';
import { useStudySettingsStore } from '@/stores/studySettings';
import {
  CustomButton
} from '@/components';


defineProps({
  openAvatarCropDialog: {
    type: Boolean,
    required: true
  }
});

const studySettingsStore = useStudySettingsStore();

const fileInput = ref();

const emit = defineEmits(['update:openAvatarCropDialog']);

const triggerFileInput = () => {
  if (fileInput.value) {
    fileInput.value.click();
  }
};

const handleFileChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target?.files && target.files[0]) {
    const file = target.files[0];
    const reader = new FileReader();
    reader.onload = e => {
      studySettingsStore.avatar = (e.target?.result as string)?.split('base64,')[1];
    };
    reader.readAsDataURL(file);
    emit('update:openAvatarCropDialog', true);
  }
};
</script>

<template>
  <div>
    <CustomButton text="Change Avatar" @click="triggerFileInput" :loading="studySettingsStore.isAvatarLoading" />
    <input type="file"
      ref="fileInput"
      @change="handleFileChange"
      accept="image/*"
      style="display: none;" />
  </div>
</template>

<style scoped lang="scss">

</style>
